import { render, staticRenderFns } from "./RwProToTeam.vue?vue&type=template&id=01519850&scoped=true"
import script from "./RwProToTeam.vue?vue&type=script&lang=ts"
export * from "./RwProToTeam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01519850",
  null
  
)

export default component.exports